import { LegacyOverlayGeometry } from "../../../lib/alt1/LegacyOverlayGeometry";
import { ImageFingerprint } from "../../../lib/util/ImageFingerprint";
import { ImageDetect } from "alt1";
import { async_lazy, LazyAsync } from "../../../lib/Lazy";
import { Vector2 } from "../../../lib/math";
import { util } from "../../../lib/util/util";
var findBestMatch = util.findBestMatch;
export class LockBoxReader {
    constructor(tile_reference) {
        this.tile_reference = tile_reference;
    }
    identifyTile(fingerprint) {
        return findBestMatch(this.tile_reference, ref => ImageFingerprint.similarity(ref.reference_fingerprint, fingerprint));
    }
}
(function (LockBoxReader) {
    LockBoxReader._instance = async_lazy(async () => new LockBoxReader(await tile_reference.get()));
    async function instance() {
        return LockBoxReader._instance.get();
    }
    LockBoxReader.instance = instance;
    var count = util.count;
    LockBoxReader.TILE_SIZE = { x: 30, y: 30 };
    const SPACE_BETWEEN_TILES = { x: 8, y: 8 };
    const TILE_OFFSET = Vector2.add(LockBoxReader.TILE_SIZE, SPACE_BETWEEN_TILES);
    const TILE_KERNEL_SIZE = { x: 5, y: 5 };
    const SIZE = 5;
    const FINGERPRINT_TYPE = ImageFingerprint.TypeRGB;
    const tile_reference = new LazyAsync(async () => {
        return [
            {
                value: 0, reference_fingerprint: ImageFingerprint.get(await ImageDetect.imageDataFromUrl("/alt1anchors/lockbox_tiles/melee.png"), { x: 0, y: 0 }, LockBoxReader.TILE_SIZE, TILE_KERNEL_SIZE, FINGERPRINT_TYPE)
            },
            {
                value: 1, reference_fingerprint: ImageFingerprint.get(await ImageDetect.imageDataFromUrl("/alt1anchors/lockbox_tiles/range.png"), { x: 0, y: 0 }, LockBoxReader.TILE_SIZE, TILE_KERNEL_SIZE, FINGERPRINT_TYPE)
            },
            {
                value: 2, reference_fingerprint: ImageFingerprint.get(await ImageDetect.imageDataFromUrl("/alt1anchors/lockbox_tiles/mage.png"), { x: 0, y: 0 }, LockBoxReader.TILE_SIZE, TILE_KERNEL_SIZE, FINGERPRINT_TYPE)
            },
            {
                value: 0, reference_fingerprint: ImageFingerprint.get(await ImageDetect.imageDataFromUrl("/alt1anchors/lockbox_tiles/melee_active.png"), { x: 0, y: 0 }, LockBoxReader.TILE_SIZE, TILE_KERNEL_SIZE, FINGERPRINT_TYPE)
            },
            {
                value: 1, reference_fingerprint: ImageFingerprint.get(await ImageDetect.imageDataFromUrl("/alt1anchors/lockbox_tiles/range_active.png"), { x: 0, y: 0 }, LockBoxReader.TILE_SIZE, TILE_KERNEL_SIZE, FINGERPRINT_TYPE)
            },
            {
                value: 2, reference_fingerprint: ImageFingerprint.get(await ImageDetect.imageDataFromUrl("/alt1anchors/lockbox_tiles/mage_active.png"), { x: 0, y: 0 }, LockBoxReader.TILE_SIZE, TILE_KERNEL_SIZE, FINGERPRINT_TYPE)
            },
        ];
    });
    const MODAL_BODY_TO_TL_TILE_OFFSET = { x: 42, y: 17 };
    class CapturedLockbox {
        constructor(modal, reader) {
            this.modal = modal;
            this.reader = reader;
            this.puzzle_computed = false;
            this.puzzle = null;
            this.isBroken = false;
            this.brokenReason = "";
            this.tile_area = modal.body.getSubSection({
                origin: MODAL_BODY_TO_TL_TILE_OFFSET,
                size: Vector2.add(Vector2.scale(SIZE, LockBoxReader.TILE_SIZE), Vector2.scale(SIZE - 1, SPACE_BETWEEN_TILES))
            });
            this.tiles = new Array(SIZE).fill(null).map(() => new Array(SIZE).fill(null));
        }
        tileOrigin(tile, on_screen = false) {
            if (on_screen) {
                return Vector2.add(Vector2.mul(TILE_OFFSET, tile), this.tile_area.screenRectangle().origin);
            }
            else {
                return Vector2.add(Vector2.mul(TILE_OFFSET, tile));
            }
        }
        getTile(index) {
            if (!this.tiles[index.y][index.x]) {
                const o = this.tileOrigin(index);
                const fingerprint = ImageFingerprint.get(this.tile_area.getData(), o, LockBoxReader.TILE_SIZE, TILE_KERNEL_SIZE, FINGERPRINT_TYPE);
                const best = this.reader.identifyTile(fingerprint);
                this.tiles[index.y][index.x] = {
                    image: fingerprint,
                    value: best.score < 0.8 ? null : best.value.value,
                };
            }
            return this.tiles[index.y][index.x];
        }
        readGrid() {
            for (let x = 0; x < SIZE; x++) {
                for (let y = 0; y < SIZE; y++) {
                    this.getTile({ x, y });
                }
            }
            return this.tiles;
        }
        getState() {
            const grid = this.readGrid();
            const broken_count = count(grid.flat(), t => t.value == null);
            if (broken_count > 15)
                return "likelyclosed";
            else if (broken_count > 0)
                return "likelyconcealed";
            else
                return "okay";
        }
        getPuzzle() {
            if (!this.puzzle_computed) {
                const grid = this.readGrid();
                const is_broken = grid.some(row => row.some(t => t.value == null));
                if (is_broken)
                    this.puzzle = null;
                else
                    this.puzzle = {
                        tile_rows: grid.map(r => r.map(t => t.value))
                    };
                this.puzzle_computed = true;
            }
            return this.puzzle;
        }
        showDebugOverlay() {
            if (!this.debug_overlay) {
                this.debug_overlay = new LegacyOverlayGeometry();
            }
            this.debug_overlay.clear();
            this.debug_overlay.render();
        }
    }
    LockBoxReader.CapturedLockbox = CapturedLockbox;
})(LockBoxReader || (LockBoxReader = {}));
